import React from 'react';

import {
  BrowserRouter,
} from "react-router";

import ReactDOM from 'react-dom/client';

import './index.css';
import { logAnalyticsEvent, logError } from './analytics/analytics';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import { AppProvider } from './contextProviders/AppProvider';
import { AuthProvider } from './contextProviders/AuthProvider';
import { DataProvider } from './contextProviders/DataProvider';
import { USGAProvider } from './contextProviders/USGAProvider';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppProvider>
            <DataProvider>
              <USGAProvider>
                <App />
              </USGAProvider>
            </DataProvider>
          </AppProvider>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

window.addEventListener('unhandledrejection', (event) => {
  const err = event.reason as { code?: string };
  if (err?.code === 'unauthenticated') return;
  logError('unhandledrejection', event.reason);
});

reportWebVitals((metric) => {
  logAnalyticsEvent('web_vitals', {
    metric_name: metric.name,
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    rating: metric.rating,
  });
});
